module.exports = __webpack_public_path__ + "img/leftcalf-endomorph-female.3994c5c9.svg";